<template>
  <div class="timeIsEnd">报名时间已过</div>
</template>

<script>
export default {
  name: 'timeIsEnd'
}
</script>

<style scoped lang="less">
.timeIsEnd {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  text-align: center;
  font-size: 20px;
  padding-top: 50px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/timeIsEnd.vue